<div class="py-[30px]">
  <div class="v4-layout-block">
    <div class="v4-layout-form-title">
      {{ "property-property_detail-channels_html_关联的房源" | translate }}
      <!-- Linked Listings -->
    </div>
    <div class="">
      <nz-table
        #nzTable
        class="v4-layout-list"
        [nzFrontPagination]="false"
        [nzData]="listOfLinkedListings"
        [nzTotal]="total"
        [(nzPageIndex)]="page"
        [nzPageSize]="pageSize"
        nzPaginationType="small"
        [nzShowTotal]="totalTpl">
        <thead>
          <tr>
            <th class="w-1/2">
              {{ "word.house_list" | translate }}
              <!-- Listings -->
            </th>
            <th class="w-1/2"></th>
          </tr>
        </thead>
        <tbody class="v4-layout-list-body">
          <tr *ngFor="let house of nzTable.data">
            <td>
              <div class="flex flex-row items-center break-all">
                <div class="relative mr-2">
                  <img
                    class="absolute left-1 top-1 w-[18px] h-[18px] rounded-full"
                    [src]="(house.thirdparty_type | thirdparty)?.icon_color_bg"
                    alt="" />
                  <span class="absolute right-1 top-1 count">{{ house.inventory }}</span>
                  <img
                    class="w-20 h-14 rounded-[10px]"
                    src="/assets/status/placeholder.png"
                    hostPlaceholder
                    [delaySrc]="house?.cover?.small_url"
                    alt="" />
                </div>
                <div>
                  <div class="ellipsis-line-2 text-m mb-1">{{ house.title }}</div>
                  <div class="text-s">{{ house.thirdparty_username }}</div>
                </div>
              </div>
            </td>
            <td>
              <div class="space-nowrap text-right">
                <a class="mr-2" [href]="house.housing_link" target="_blank">
                  <button nz-button>{{ "word.preview" | translate }}</button>
                </a>

                <button class="mr-2" nz-button (click)="onUnbind(house)">{{ "word.unbind" | translate }}</button>

                <button *ngIf="house.is_shelf && house.sync_status !== -1" nz-button (click)="onUnshelf(house)">
                  <!-- 下架 -->
                  {{ "house.pull_off_shelves" | translate }}
                </button>
                <button *ngIf="!house.is_shelf && house.sync_status !== -1" nz-button (click)="onShelf(house)">
                  <!-- 上架 -->
                  {{ "house.put_on_shelves" | translate }}
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <ng-template #totalTpl>
        {{ "component-page_html_总数" | translate: { number: total } }}
        <!-- {{ total }} items -->
      </ng-template>
    </div>
  </div>
</div>
